export const RANKING_TYPES = {
  doubles: {
    name: '공식',
    list: 'doublesPlayers',
    rank: 'doubles_rank',
    rating: 'doubles_rating',
    wins: 'doubles_wins',
    losses: 'doubles_losses',
    count: 'doubles_total_matches',
  },
  friendly: {
    name: '친선',
    list: 'friendlyPlayers',
    rank: 'friendly_rank',
    rating: 'friendly_rating',
    wins: 'friendly_wins',
    losses: 'friendly_losses',
    count: 'friendly_total_matches',
  },
};
